import { render, staticRenderFns } from "./BurnOqcScreen.vue?vue&type=template&id=209bfbe8&scoped=true&"
import script from "./BurnOqcScreen.vue?vue&type=script&lang=js&"
export * from "./BurnOqcScreen.vue?vue&type=script&lang=js&"
import style0 from "./BurnOqcScreen.vue?vue&type=style&index=0&id=209bfbe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209bfbe8",
  null
  
)

export default component.exports